var map = {
	"./ion-action-sheet.entry.js": [
		"6618",
		"chunk-5428831d"
	],
	"./ion-alert.entry.js": [
		"f06c",
		"chunk-0395d10d"
	],
	"./ion-app_8.entry.js": [
		"c215",
		"chunk-22a467a9"
	],
	"./ion-avatar_3.entry.js": [
		"cf12",
		"chunk-5a060292"
	],
	"./ion-back-button.entry.js": [
		"4b35",
		"chunk-69d2ea6b"
	],
	"./ion-backdrop.entry.js": [
		"429d",
		"chunk-2d0c073f"
	],
	"./ion-button_2.entry.js": [
		"4453",
		"chunk-25bf9f9d"
	],
	"./ion-card_5.entry.js": [
		"070b",
		"chunk-54060722"
	],
	"./ion-checkbox.entry.js": [
		"dfd8",
		"chunk-09476136"
	],
	"./ion-chip.entry.js": [
		"430d",
		"chunk-08fcc0e8"
	],
	"./ion-col_3.entry.js": [
		"6a8a",
		"chunk-2d0da04a"
	],
	"./ion-datetime_3.entry.js": [
		"c15b",
		"chunk-054925db"
	],
	"./ion-fab_3.entry.js": [
		"dd47",
		"chunk-3eba00d8"
	],
	"./ion-img.entry.js": [
		"9588",
		"chunk-2d0e5812"
	],
	"./ion-infinite-scroll_2.entry.js": [
		"d1e5",
		"chunk-2d21da73"
	],
	"./ion-input.entry.js": [
		"d111",
		"chunk-38236a24"
	],
	"./ion-item-option_3.entry.js": [
		"1bb3",
		"chunk-5fe0cd19"
	],
	"./ion-item_8.entry.js": [
		"69da",
		"chunk-5a722b7b"
	],
	"./ion-loading.entry.js": [
		"53a5",
		"chunk-6d1ec229"
	],
	"./ion-menu_3.entry.js": [
		"cb00",
		"chunk-09af4288"
	],
	"./ion-modal.entry.js": [
		"1ad0",
		"chunk-7e18ed80"
	],
	"./ion-nav_2.entry.js": [
		"e44f",
		"chunk-5e134154"
	],
	"./ion-popover.entry.js": [
		"4285",
		"chunk-5c5fa541"
	],
	"./ion-progress-bar.entry.js": [
		"9b72",
		"chunk-1da37897"
	],
	"./ion-radio_2.entry.js": [
		"beb3",
		"chunk-0ec4da32"
	],
	"./ion-range.entry.js": [
		"719f",
		"chunk-54ed0a98"
	],
	"./ion-refresher_2.entry.js": [
		"0a47",
		"chunk-779a3249"
	],
	"./ion-reorder_2.entry.js": [
		"6672",
		"chunk-5786b736"
	],
	"./ion-ripple-effect.entry.js": [
		"c8da",
		"chunk-2d218068"
	],
	"./ion-route_4.entry.js": [
		"10e8",
		"chunk-85be132e"
	],
	"./ion-searchbar.entry.js": [
		"8625",
		"chunk-a96a964c"
	],
	"./ion-segment_2.entry.js": [
		"0c02",
		"chunk-465dc0b4"
	],
	"./ion-select_3.entry.js": [
		"d25f",
		"chunk-79d93dbc"
	],
	"./ion-slide_2.entry.js": [
		"05dd",
		"chunk-2d0a463b"
	],
	"./ion-spinner.entry.js": [
		"e11b",
		"chunk-f926fba8"
	],
	"./ion-split-pane.entry.js": [
		"aae8",
		"chunk-2d213189"
	],
	"./ion-tab-bar_2.entry.js": [
		"a2bb",
		"chunk-02b0f8aa"
	],
	"./ion-tab_2.entry.js": [
		"6725",
		"chunk-5e3de68e"
	],
	"./ion-text.entry.js": [
		"ed3b",
		"chunk-310ed166"
	],
	"./ion-textarea.entry.js": [
		"8798",
		"chunk-ead3eb46"
	],
	"./ion-toast.entry.js": [
		"c1a5",
		"chunk-41a85a99"
	],
	"./ion-toggle.entry.js": [
		"bef2",
		"chunk-58ea8dc7"
	],
	"./ion-virtual-scroll.entry.js": [
		"5fd7",
		"chunk-2d0d43da"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "05fe";
module.exports = webpackAsyncContext;